import type * as React from 'react';

import { cn } from '@/lib/utils';

type AspectRatioProps = React.ComponentProps<'div'> & {
    ratio?: number;
};

function AspectRatio({ ratio = 1, className, style, ...props }: AspectRatioProps) {
    return <div className={cn('relative', className)} style={{ aspectRatio: ratio, ...style }} {...props} />;
}

export { AspectRatio };
